import { Play } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { GreekWatermark } from "@/components/GreekWatermark";

const PETER_VIDEO = "/api/files/elysium-training-club/vlog/d14c2645-4498-4e26-aa7e-baf966b2e993.mp4";
const PETER_POSTER = "/api/files/elysium-training-club/vlog/4f80bc30-2e6f-4804-a48b-745e8f275075.jpg";

export default function Coaching() {
  return (
    <div className="pt-28 sm:pt-36 pb-20 sm:pb-28" data-testid="coaching-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-14 relative">
        <GreekWatermark letter="Θ" className="-top-10 left-1/2 -translate-x-1/2" />
        <Reveal>
          <p className="font-accent italic text-gold text-lg mb-3">Expert coaching</p>
          <h1 className="font-anton uppercase tracking-tighter text-cream text-4xl sm:text-6xl">Coaching That Cares</h1>
          <p className="text-smoke mt-4 max-w-xl mx-auto">
            Every session at Elysium is led, not left on autopilot. Watch Head Coach Peter Crudge
            break down technique before the work begins.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.05} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative aspect-[9/16] max-w-xs sm:max-w-sm mx-auto border border-gold/25 bg-void" data-testid="coaching-video-feature">
          <video
            src={PETER_VIDEO}
            poster={PETER_POSTER}
            controls
            playsInline
            preload="metadata"
            className="w-full h-full object-cover"
            data-testid="coaching-video-player"
          />
        </div>

        <div className="mt-8 bg-surface border border-line p-7 sm:p-9 max-w-xl mx-auto">
          <p className="text-gold text-xs uppercase tracking-widest flex items-center gap-2 mb-3">
            <Play className="h-3.5 w-3.5" /> Head Coach — Peter Crudge
          </p>
          <p className="text-smoke leading-relaxed">
            Peter doesn't just call out reps — he coaches every one of them. British Weightlifting
            qualified and hands-on with every class, he built Elysium's coaching standard from the
            ground up: watch the movement, fix the cause not the symptom, and never let a rep go
            unnoticed. Whether you're chasing your first pull-up or your next PB, Peter coaches the
            person in front of him — not a generic program.
          </p>
        </div>
      </Reveal>
    </div>
  );
}
